import React from 'react';

const icon = ({ className = '', ...props }) => (
  <span className={`svg-icon ${className}`} {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
      <circle cx="22.5" cy="22.5" r="22" fill="none" stroke="currentColor" />
      <path d="M17.376 17.948c-2.604 0-4.648 1.68-4.648 5.096 0 3.444 1.974 5.124 4.648 5.124 2.534 0 4.662-1.736 4.662-5.124 0-3.43-2.044-5.096-4.662-5.096zm0 1.4c2.072 0 2.968 1.694 2.968 3.696 0 2.198-.91 3.71-2.968 3.71-2.044 0-2.954-1.708-2.954-3.71 0-2.142.938-3.696 2.954-3.696zm6.878-1.232V28h1.652v-4.046h2.002L30.302 28h1.96l-2.716-4.368a2.568 2.568 0 002.058-2.688 2.66 2.66 0 00-.7-1.904 3.503 3.503 0 00-2.688-.924zm1.652 1.33h2.212c1.302 0 1.792.658 1.792 1.526 0 1.05-.49 1.652-1.792 1.652h-2.212z" fill="currentColor" />
    </svg>
  </span>
);

export default icon;
